import ListItemV2 from '@/component/Common/KeyDetails/component/ListItemV2'
import React from 'react'
import { format } from 'date-fns'
import styles from './IndustryDetails.module.scss'
import { string } from 'prop-types'
const IndustryDetails = ({ lang, date }) => {
  const formattedDate = format(new Date(date), 'dd/MM/yyy')
  return (
    <div className={styles.Wrap}>
      <ListItemV2 title="Classified date" value={formattedDate} />
      <ListItemV2 title="Language" value={lang} />
    </div>
  )
}
IndustryDetails.propTypes = {
  lang: string,
  date: string
}
export default IndustryDetails
